import React, { useContext, useEffect, useState} from 'react'
import './sidebar.scss'
import Dashboard from '@mui/icons-material/Dashboard';
import PeopleOutlineIcon from '@mui/icons-material/PeopleOutline';
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
import ReviewsIcon from '@mui/icons-material/Reviews';
import ChatIcon from '@mui/icons-material/Chat';
import FlightIcon from '@mui/icons-material/Flight';
import PaymentIcon from '@mui/icons-material/Payment';
import ContactsIcon from '@mui/icons-material/Contacts';
import PaidIcon from '@mui/icons-material/Paid';
import SettingsIcon from '@mui/icons-material/Settings';
import ForumIcon from '@mui/icons-material/Forum';
import AppsIcon from '@mui/icons-material/Apps';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import LogoutIcon from '@mui/icons-material/Logout';
import CampaignIcon from '@mui/icons-material/Campaign';
import MoneyIcon from '@mui/icons-material/Money';
import { NavLink, Link } from 'react-router-dom'
import { DarkModeContext } from '../../context/darkModeContext';
import {signOut } from "firebase/auth";
import { auth, db } from '../../firebase'
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';
import { doc, getDoc } from 'firebase/firestore';


const Sidebar = () => {

  const { darkMode, dispatch : setDarkMode } = useContext(DarkModeContext)

  const { currentUser } = useContext(AuthContext)

  const user = currentUser.uid;

  const [adminRole, setAdminRole] = useState("")

  console.log('user info: ', user)

  
  
  const getAdminRole = async() => {
  
        const docRef = doc(db, "admins", user);
  
        const docSnap = await getDoc(docRef);
  
        
        if (docSnap.exists()) {
  
          // console.log("Document data:", docSnap.data());
          setAdminRole(docSnap.data().role)
          // console.log(userData)
        } else {
          // doc.data() will be undefined in this case
          console.log("No such document!");
        }
    }

    useEffect(()=>  {

      getAdminRole()

    }, [])


  const adminNav = [
    { id : 1, text : "Dashboard", link: "/", iconName : Dashboard, heading:"LIST"},
    { id : 2, text : "Applicants", link: "/applicants", iconName : PeopleOutlineIcon, heading:""},
    { id : 3, text : "Visa Applications", link: "/applications", iconName : FlightIcon, heading:""},
    { id : 4, text : "Application History", link: "/applicationHistory", iconName : AppsIcon, heading:""},
    { id : 5, text : "Dollar Payments", link: "/dollarPayments", iconName : PaidIcon, heading:""},
    { id : 5, text : "Naira Payments", link: "/nairaPayments", iconName : MoneyIcon, heading:"USEFUL"},
    { id : 6, text : "Dollar Charges", link: "/dollarcharges", iconName : AttachMoneyIcon, heading:""},
    { id : 7, text : "Naira Charges", link: "/nairacharges", iconName : MoneyIcon, heading:""},
    // { id : 8, text : "Messages", link: "/messages", iconName : ForumIcon, heading:""},
    // { id : 9, text : "Chats", link: "/chats", iconName : ChatIcon, heading:""},
    { id : 10, text : "Reviews", link: "/reviews", iconName : ReviewsIcon, heading:""},
    { id : 11, text : "Announcement", link: "/announcement", iconName : CampaignIcon, heading:""},
    // { id : 12, text : "Notifications", link: "/notifications", iconName : NotificationsNoneIcon, heading:"WEBSITE"},
    { id : 13, text : "Contacts", link: "/contacts", iconName : ContactsIcon, heading:"ADMIN"},
    { id : 14, text : "Settings", link: "/settings", iconName : SettingsIcon, heading:""},
  ]


  const subadminNav = [
      { id : 1, text : "Dashboard", link: "/", iconName : Dashboard, heading:"LIST"},
      { id : 2, text : "Applicants", link: "/applicants", iconName : PeopleOutlineIcon, heading:""},
      { id : 3, text : "Visa Applications", link: "/applications", iconName : FlightIcon, heading:""},
      { id : 4, text : "Application History", link: "/applicationHistory", iconName : AppsIcon, heading:""},
      { id : 5, text : "Dollar Payments", link: "/dollarPayments", iconName : PaidIcon, heading:""},
      { id : 5, text : "Naira Payments", link: "/nairaPayments", iconName : PaymentIcon, heading:"USEFUL"},
      { id : 6, text : "Dollar Charges", link: "/dollarcharges", iconName : AttachMoneyIcon, heading:""},
      { id : 7, text : "Naira Charges", link: "/nairacharges", iconName : MoneyIcon, heading:""},
      // { id : 8, text : "Messages", link: "/messages", iconName : ForumIcon, heading:""},
      { id : 10, text : "Reviews", link: "/reviews", iconName : ReviewsIcon, heading:""},
      { id : 11, text : "Announcement", link: "/announcement", iconName : CampaignIcon, heading:""},
      // { id : 12, text : "Notifications", link: "/notifications", iconName : NotificationsNoneIcon, heading:"WEBSITE"},
      { id : 13, text : "Contacts", link: "/contacts", iconName : ContactsIcon, heading:"ADMIN"},
      // { id : 14, text : "Settings", link: "/settings", iconName : SettingsIcon, heading:""},
    ]

  const navigate = useNavigate()

  const { logout, dispatch : setLogout} = useContext(AuthContext)

  const { isActive, setIsActive } = useState(null)

 

  const logOut = () =>{

    signOut(auth).then(() => {

      setLogout({ type: 'LOGOUT' });

      localStorage.removeItem('currentUser');

      navigate('/login')

    }).catch((error) => {

      console.log(error)

    });

  }



  return (

    <div className='sidebar'>

      <div className='top-sidebar'>

          <div className="top">

            <Link to="/" style={{textDecoration:'none'}}>

                <span className='logo'>VISADOC ADMIN</span>

            </Link>
            
          </div>
          <hr />
          <div className="center">
            <ul>
              <p className='title'>MAIN</p>

               {/* {values.map((value) => (
                  <div key = {value.id}>

                   
                   <li key = {value.id} >
                      <NavLink to={value.link} style={({ isActive }) => ({
                        backgroundColor: isActive &&  "#ece8ff",
                        textDecoration:"none",
                        display:"flex",
                        width:"100%",
                        height:"100%",
                        padding:"5px",
                      })}>
                      <value.iconName className='icon'/>
                      <span>{value.text}</span>
                      </NavLink>
                      
                    </li>
                    {value.heading !== "" && <p className='title'>{value.heading}</p>}
                  </div>

                ))
              } */}


              {

               adminRole === "adminAccess"
               
               
               ?
              
              
              adminNav.map((value) => (
                  <>
                   
                   <li key = {value.id} >
                      <NavLink to={value.link} style={({ isActive }) => ({
                        backgroundColor: isActive &&  "#ece8ff",
                        textDecoration:"none",
                        display:"flex",
                        width:"100%",
                        height:"100%",
                        padding:"5px",
                      })}>
                      <value.iconName className='icon'/>
                      <span>{value.text}</span>
                      </NavLink>
                      
                    </li>
                    {value.heading !== "" && <p className='title'>{value.heading}</p>}
                  </>
                
              ))

            
              :


               subadminNav.map((value) => (
                  <>
                   
                   <li key = {value.id} >
                      <NavLink to={value.link} style={({ isActive }) => ({
                        backgroundColor: isActive &&  "#ece8ff",
                        textDecoration:"none",
                        display:"flex",
                        width:"100%",
                        height:"100%",
                        padding:"5px",
                      })}>
                      <value.iconName className='icon'/>
                      <span>{value.text}</span>
                      </NavLink>
                      
                    </li>
                    {value.heading !== "" && <p className='title'>{value.heading}</p>}
                  </>
                
              ))
              
              }
          
              
            </ul>
          </div>
          <div className="bottom">
            <div className="colorOption" onClick={() => setDarkMode({type:"LIGHT"})}></div>
            <div className="colorOption" onClick={() => setDarkMode({type:"DARK"})}></div>
          </div> 
      </div>
      <div className='bottom-sidebar'>
            <LogoutIcon className='logout-icon'/>
            <span onClick={logOut}>Logout</span>
      </div>
    </div>
  )
}

export default Sidebar









// import React, { useContext, useEffect, useState} from 'react'
// import './sidebar.scss'
// import Dashboard from '@mui/icons-material/Dashboard';
// import PeopleOutlineIcon from '@mui/icons-material/PeopleOutline';
// import StoreIcon from '@mui/icons-material/Store';
// import Inventory2Icon from '@mui/icons-material/Inventory2';
// import DeliveryDiningIcon from '@mui/icons-material/DeliveryDining';
// import BarChartIcon from '@mui/icons-material/BarChart';
// import ListIcon from '@mui/icons-material/List';
// import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
// import ReviewsIcon from '@mui/icons-material/Reviews';
// import LocalTaxiIcon from '@mui/icons-material/LocalTaxi';
// import LocalShippingIcon from '@mui/icons-material/LocalShipping';
// import RedeemIcon from '@mui/icons-material/Redeem';
// import PaymentIcon from '@mui/icons-material/Payment';
// import ChatIcon from '@mui/icons-material/Chat';
// import SubscriptionsOutlinedIcon from '@mui/icons-material/SubscriptionsOutlined';
// import EmailIcon from '@mui/icons-material/Email';
// import GradingIcon from '@mui/icons-material/Grading';
// // import PsychologyIcon from '@mui/icons-material/Psychology';
// import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
// import SettingsIcon from '@mui/icons-material/Settings';
// import LiquorIcon from '@mui/icons-material/Liquor';
// import CampaignIcon from '@mui/icons-material/Campaign';
// import PermIdentityIcon from '@mui/icons-material/PermIdentity';
// import LogoutIcon from '@mui/icons-material/Logout';
// import { NavLink, Link } from 'react-router-dom'
// import { DarkModeContext } from '../../context/darkModeContext';
// import {signOut } from "firebase/auth";
// import { auth, db } from '../../firebase'
// import { useNavigate } from 'react-router-dom';
// import { AuthContext } from '../../context/AuthContext';
// import { doc, getDoc } from 'firebase/firestore';


// const Sidebar = () => {

//   const { darkMode, dispatch : setDarkMode } = useContext(DarkModeContext)

//   const { currentUser } = useContext(AuthContext)

//   const user = currentUser.uid;

//   const [adminRole, setAdminRole] = useState("")

//   console.log('user info: ', user)

  
  
//   const getAdminRole = async() => {
  
//         const docRef = doc(db, "admins", user);
  
//         const docSnap = await getDoc(docRef);
  
        
//         if (docSnap.exists()) {
  
//           // console.log("Document data:", docSnap.data());
//           setAdminRole(docSnap.data().role)
//           // console.log(userData)
//         } else {
//           // doc.data() will be undefined in this case
//           console.log("No such document!");
//         }
//     }

//     useEffect(()=>  {

//       getAdminRole()

//     }, [])


//   const adminNav = [
//     { id : 1, text : "Dashboard", link: "/", iconName : Dashboard, heading:"LIST"},
//     { id : 2, text : "Users", link: "/customers", iconName : PeopleOutlineIcon, heading:""},
//     { id : 3, text : "Subscribers", link: "/subscribers", iconName : SubscriptionsOutlinedIcon, heading:"OUTLETS"},
//     { id : 4, text : "All", link: "/outlets", iconName : Inventory2Icon, heading:""},
//     { id : 6, text : "Paid", link: "/paid", iconName : Inventory2Icon, heading:""},
//     { id : 5, text : "Unpaid", link: "/unpaid", iconName : Inventory2Icon, heading:"NOTIFICATION"},
//     { id : 7, text : "Group", link: "/group", iconName : NotificationsNoneIcon, heading:"USEFUL"},
//     // { id : 8, text : "Individual", link: "/individual", iconName : NotificationsActiveIcon, heading:"USEFUL"},
//     { id : 9, text : "Events", link: "/events", iconName : LiquorIcon, heading:""},
//     { id : 10, text : "Adverts", link: "/adverts", iconName : CampaignIcon, heading:""},

//     // { id : 11, text : "Analythics", link: "/analythics", iconName : RedeemIcon, heading:""},
//     { id : 12, text : "Reviews", link: "/reviews", iconName : ReviewsIcon, heading:""},
//     { id : 13, text : "Messages", link: "/messages", iconName : EmailIcon, heading:"WHAT NEXT?"},
//     { id : 14, text : "Releases", link: "/releases", iconName : RedeemIcon, heading:"SERVICES"},
//     { id : 15, text : "Staff", link: "/staff", iconName : PermIdentityIcon, heading:""},
//     { id : 16, text : "Settings", link: "/settings", iconName : SettingsIcon, heading:"USER"},
//     { id : 17, text : "Profile", link: "/profile", iconName : PermIdentityIcon, heading:""},
//   ]



//     const subadminNav = [
//     { id : 1, text : "Dashboard", link: "/", iconName : Dashboard, heading:"LIST"},
//     { id : 2, text : "Users", link: "/customers", iconName : PeopleOutlineIcon, heading:""},
//     { id : 3, text : "Subscribers", link: "/subscribers", iconName : SubscriptionsOutlinedIcon, heading:"OUTLETS"},
//     { id : 4, text : "All", link: "/outlets", iconName : Inventory2Icon, heading:""},
//     { id : 5, text : "Paid", link: "/paid", iconName : Inventory2Icon, heading:""},
//     { id : 6, text : "Unpaid", link: "/unpaid", iconName : Inventory2Icon, heading:"NOTIFICATION"},
//     { id : 7, text : "Group", link: "/group", iconName : NotificationsNoneIcon, heading:"USEFUL"},
//     { id : 8, text : "Events", link: "/events", iconName : LiquorIcon, heading:""},
//     { id : 9, text : "Adverts", link: "/adverts", iconName : CampaignIcon, heading:""},
//     // { id : 7, text : "Analythics", link: "/analythics", iconName : RedeemIcon, heading:""},
//     { id : 10, text : "Reviews", link: "/reviews", iconName : ReviewsIcon, heading:""},
//     { id : 11, text : "Messages", link: "/messages", iconName : EmailIcon, heading:"WHAT NEXT?"},
//     { id : 12, text : "Releases", link: "/releases", iconName : RedeemIcon, heading:"USER"},
//     { id : 13, text : "Profile", link: "/profile", iconName : PermIdentityIcon, heading:""},
//   ]



//   const agencyNav = [
//     { id : 1, text : "Dashboard", link: "/", iconName : Dashboard, heading:"LIST"},
//     { id : 2, text : "Users", link: "/customers", iconName : PeopleOutlineIcon, heading:""},
//     { id : 2, text : "Subscribers", link: "/subscribers", iconName : SubscriptionsOutlinedIcon, heading:"OUTLETS"},
//     { id : 3, text : "All", link: "/outlets", iconName : Inventory2Icon, heading:""},
//     { id : 4, text : "Paid", link: "/paid", iconName : Inventory2Icon, heading:""},
//     { id : 5, text : "Unpaid", link: "/unpaid", iconName : Inventory2Icon, heading:"USER"},
//     { id : 6, text : "Profile", link: "/profile", iconName : PermIdentityIcon, heading:""},
//   ]



//   const navigate = useNavigate()

//   const { logout, dispatch : setLogout} = useContext(AuthContext)

//   const { isActive, setIsActive } = useState(null)

 

//   const logOut = () =>{

//     signOut(auth).then(() => {

//       setLogout({ type: 'LOGOUT' });

//       localStorage.removeItem('currentUser');

//       navigate('/login')

//     }).catch((error) => {

//       console.log(error)

//     });

//   }



//   return (

//     <div className='sidebar'>

//       <div className='top-sidebar'>

//           <div className="top">

//             <Link to="/" style={{textDecoration:'none'}}>

//                 <span className='logo'>CHILLAXIA ADMIN</span>

//             </Link>
            
//           </div>
//           <hr />
//           <div className="center">
//             <ul>
//               <p className='title'>MAIN</p>


//               {

//                adminRole === "adminAccess"
               
               
//                ?
              
              
//               adminNav.map((value) => (
//                   <>
                   
//                    <li key = {value.id} >
//                       <NavLink to={value.link} style={({ isActive }) => ({
//                         backgroundColor: isActive &&  "#ece8ff",
//                         textDecoration:"none",
//                         display:"flex",
//                         width:"100%",
//                         height:"100%",
//                         padding:"5px",
//                       })}>
//                       <value.iconName className='icon'/>
//                       <span>{value.text}</span>
//                       </NavLink>
                      
//                     </li>
//                     {value.heading !== "" && <p className='title'>{value.heading}</p>}
//                   </>
                
//               ))

//               :

//               adminRole === "subadminAccess"

//               ?


//                subadminNav.map((value) => (
//                   <>
                   
//                    <li key = {value.id} >
//                       <NavLink to={value.link} style={({ isActive }) => ({
//                         backgroundColor: isActive &&  "#ece8ff",
//                         textDecoration:"none",
//                         display:"flex",
//                         width:"100%",
//                         height:"100%",
//                         padding:"5px",
//                       })}>
//                       <value.iconName className='icon'/>
//                       <span>{value.text}</span>
//                       </NavLink>
                      
//                     </li>
//                     {value.heading !== "" && <p className='title'>{value.heading}</p>}
//                   </>
                
//               ))

//               :

//               agencyNav.map((value) => (

//                   <>
                   
//                    <li key = {value.id} >
//                       <NavLink to={value.link} style={({ isActive }) => ({
//                         backgroundColor: isActive &&  "#ece8ff",
//                         textDecoration:"none",
//                         display:"flex",
//                         width:"100%",
//                         height:"100%",
//                         padding:"5px",
//                       })}>
//                       <value.iconName className='icon'/>
//                       <span>{value.text}</span>
//                       </NavLink>
                      
//                     </li>
//                     {value.heading !== "" && <p className='title'>{value.heading}</p>}
//                   </>
                
//               ))
              
              
//               }
          
              
//             </ul>
//           </div>
//           <div className="bottom">
//             <div className="colorOption" onClick={() => setDarkMode({type:"LIGHT"})}></div>
//             <div className="colorOption" onClick={() => setDarkMode({type:"DARK"})}></div>
//           </div> 
//       </div>
//       <div className='bottom-sidebar'>
//             <LogoutIcon className='logout-icon'/>
//             <span onClick={logOut}>Logout</span>
//       </div>
//     </div>
//   )
// }

// export default Sidebar